import * as React from "react";
import { useDispatch } from "react-redux";
import { setCurrentModal } from "../../store/slices/modalsSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";

// now we can render all what we want in the label
export default function ComponentLinkLabelWidget(props) {
  const dispatch = useDispatch();

  return (
    <div
      style={{
        userSelect: "none",
        pointerEvents: "auto",
      }}
      className="position-relative"
    >
      <button
        type="button"
        className="btn btn-secondary"
        onClick={() => {
          const targetID = props.model.parent.targetPort.parent.options.component.ID;
          const sourceID = props.model.parent.sourcePort.parent.options.component.ID;
          dispatch(
            setCurrentModal({
              modal: "activation",
              data: { targetID, sourceID },
            })
          );
        }}
      >
        Configure activation
      </button>
      <button
        type="button"
        className="btn btn-danger btn-sm rounded-circle border-0 position-absolute top-0 start-100 translate-middle"
        onClick={() => {
          props.model.parent.remove();
          props.engine.repaintCanvas();
        }}
        aria-label="Delete"
      >
        <FontAwesomeIcon icon={faX} />
      </button>
    </div>
  );
}
